export const NOTLOGIN_URL = ['agreement', 'privacy'];



// WEBPACK FOOTER //
// ./src/service/constant.js